import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';

import VpMediaTableHead from './VpMediaTableHead';
import VpMediaTableBody from './VpMediaTableBody';
import VpMediaTablePagination from './VpMediaTablePagination';
import VpDeleteModal from './VpDeleteModal';
import { useFetchCampaignSubmissions } from '../../../hooks';
import VpTableSkeleton from '../VpTableSkeleton/VpTableSkeleton';

export const VpMediaTable = () => {
  const { data, isLoading } = useFetchCampaignSubmissions();

  return isLoading ? (
    <VpTableSkeleton rowHeight={75} headHeight={39.5} />
  ) : (
    <TableContainer>
      <Table>
        <VpMediaTableHead />
        <VpMediaTableBody data={data} />
      </Table>
      <VpMediaTablePagination />
      <VpDeleteModal />
    </TableContainer>
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTable.jsx